import Matter from "matter-js";
import { Constants } from "../common/Constants";
import { isMobile } from "../common/Utilities";

const PhysicsManager = (entities: Entities, { input }: { input: any }) => {
  if (!entities || !entities.physics) return;

  let engine = entities.physics.engine;
  let flyer = entities.flyer.body;

  engine.gravity.scale = Constants.GRAVITY_SCALE;
  const jumpEventName = isMobile ? "onTouchStart" : "onMouseDown";

  const { payload } = input.find((x: any) => x.name === jumpEventName) || {};
  if (payload) {
    Matter.Body.setVelocity(flyer, {
      x: flyer.velocity.x,
      y: -Constants.JUMP_HEIGHT,
    });
  }

  return entities;
};

export default PhysicsManager;
